"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _ApiClient = _interopRequireDefault(require("../ApiClient"));

var _GroupUsageResponse = _interopRequireDefault(require("../models/GroupUsageResponse"));

var _DataResponse = _interopRequireDefault(require("../models/DataResponse"));

var _DataSecurableResponse = _interopRequireDefault(require("../models/DataSecurableResponse"));

var _Storable = _interopRequireDefault(require("../models/Storable"));

var _PagedResponse = _interopRequireDefault(require("../models/PagedResponse"));

var _PagedSecurableResponse = _interopRequireDefault(require("../models/PagedSecurableResponse"));

var _ReportResponse = _interopRequireDefault(require("../models/ReportResponse"));

var _Stream = _interopRequireDefault(require("../models/Stream"));

/**
 * Group service.
 * @module ChiRhos/api/GroupApi
 * @version v1
 */
var GroupApi =
/*#__PURE__*/
function () {
  /**
   * Constructs a new GroupApi.
   * @alias module:ChiRhos/api/GroupApi
   * @class
   * @param {module:ChiRhos/ApiClient} [apiClient] Optional API client implementation to use,
   * default to {@link module:ChiRhos/ApiClient#instance} if unspecified.
   */
  function GroupApi(apiClient) {
    (0, _classCallCheck2["default"])(this, GroupApi);
    this.apiClient = apiClient || _ApiClient["default"].instance;
  }
  /**
   * @param {Object} opts Optional parameters
   * @param {String} opts.secret
   * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing HTTP response
   */


  (0, _createClass2["default"])(GroupApi, [{
    key: "_acceptInviteWithHttpInfo",
    value: function _acceptInviteWithHttpInfo(opts) {
      opts = opts || {};
      var postBody = null;
      var pathParams = {};
      var queryParams = {
        secret: opts['secret']
      };
      var headerParams = {};
      var formParams = {};
      var authNames = [];
      var contentTypes = [];
      var accepts = [];
      var returnType = null;
      return this.apiClient.callApi('/api/Group/Invite/Accept', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType);
    }
    /**
     * @param {Object} opts Optional parameters
     * @param {String} opts.secret
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}
     */

  }, {
    key: "AcceptInvite",
    value: function AcceptInvite(opts) {
      return this._acceptInviteWithHttpInfo(opts).then(function (response) {
        return response.data;
      });
    }
    /**
     * @param {Object} opts Optional parameters
     * @param {module:ChiRhos/models/ApiEntityRawRequest} opts.request
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing HTTP response
     */

  }, {
    key: "_addFavouriteWithHttpInfo",
    value: function _addFavouriteWithHttpInfo(opts) {
      opts = opts || {};
      var postBody = opts['request'];
      var pathParams = {};
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = [];
      var contentTypes = ['application/json-patch+json', 'application/json', 'text/json', 'application/_*+json'];
      var accepts = [];
      var returnType = null;
      return this.apiClient.callApi('/api/Group/Favourite/Add', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType);
    }
    /**
     * @param {Object} opts Optional parameters
     * @param {module:ChiRhos/models/ApiEntityRawRequest} opts.request
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}
     */

  }, {
    key: "AddFavourite",
    value: function AddFavourite(opts) {
      return this._addFavouriteWithHttpInfo(opts).then(function (response) {
        return response.data;
      });
    }
    /**
     * @param {Object} opts Optional parameters
     * @param {String} opts.entityId
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing HTTP response
     */

  }, {
    key: "_deleteWithHttpInfo",
    value: function _deleteWithHttpInfo(opts) {
      opts = opts || {};
      var postBody = null;
      var pathParams = {};
      var queryParams = {
        entityId: opts['entityId']
      };
      var headerParams = {};
      var formParams = {};
      var authNames = [];
      var contentTypes = [];
      var accepts = [];
      var returnType = null;
      return this.apiClient.callApi('/api/Group', 'DELETE', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType);
    }
    /**
     * @param {Object} opts Optional parameters
     * @param {String} opts.entityId
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}
     */

  }, {
    key: "Delete",
    value: function Delete(opts) {
      return this._deleteWithHttpInfo(opts).then(function (response) {
        return response.data;
      });
    }
    /**
     * If passing in your own import identifier, make sure it is a proper GUID to avoid conflicts with other imports
     * @param {Object} opts Optional parameters
     * @param {String} opts.contentType
     * @param {String} opts.contentDisposition
     * @param {Object.<String, {String: String}>} opts.headers
     * @param {Number} opts.length
     * @param {String} opts.name
     * @param {String} opts.fileName
     * @param {String} opts.entityId
     * @param {String} opts.importIdentifier
     * @param {Boolean} opts.createDependencies  (default to false)
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:ChiRhos/models/Storable} and HTTP response
     */

  }, {
    key: "_importWithHttpInfo",
    value: function _importWithHttpInfo(opts) {
      opts = opts || {};
      var postBody = null;
      var pathParams = {};
      var queryParams = {
        ContentType: opts['contentType'],
        ContentDisposition: opts['contentDisposition'],
        Headers: opts['headers'],
        Length: opts['length'],
        Name: opts['name'],
        FileName: opts['fileName'],
        entityId: opts['entityId'],
        importIdentifier: opts['importIdentifier'],
        createDependencies: opts['createDependencies']
      };
      var headerParams = {};
      var formParams = {};
      var authNames = [];
      var contentTypes = [];
      var accepts = ['text/plain', 'application/json', 'text/json'];
      var returnType = _Storable["default"];
      return this.apiClient.callApi('/api/Group/Import', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType);
    }
    /**
     * If passing in your own import identifier, make sure it is a proper GUID to avoid conflicts with other imports
     * @param {Object} opts Optional parameters
     * @param {String} opts.contentType
     * @param {String} opts.contentDisposition
     * @param {Object.<String, {String: String}>} opts.headers
     * @param {Number} opts.length
     * @param {String} opts.name
     * @param {String} opts.fileName
     * @param {String} opts.entityId
     * @param {String} opts.importIdentifier
     * @param {Boolean} opts.createDependencies  (default to false)
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:ChiRhos/models/Storable}
     */

  }, {
    key: "Import",
    value: function Import(opts) {
      return this._importWithHttpInfo(opts).then(function (response) {
        return response.data;
      });
    }
    /**
     * Leave the &#39;ToPersonEntityId&#39; blank to send to all members of this group
     * @param {Object} opts Optional parameters
     * @param {module:ChiRhos/models/NotificationConstruct} opts.value
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing HTTP response
     */

  }, {
    key: "_createNotificationWithHttpInfo",
    value: function _createNotificationWithHttpInfo(opts) {
      opts = opts || {};
      var postBody = opts['value'];
      var pathParams = {};
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = [];
      var contentTypes = ['application/json-patch+json', 'application/json', 'text/json', 'application/_*+json'];
      var accepts = [];
      var returnType = null;
      return this.apiClient.callApi('/api/Group/CreateNotification', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType);
    }
    /**
     * Leave the &#39;ToPersonEntityId&#39; blank to send to all members of this group
     * @param {Object} opts Optional parameters
     * @param {module:ChiRhos/models/NotificationConstruct} opts.value
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}
     */

  }, {
    key: "CreateNotification",
    value: function CreateNotification(opts) {
      return this._createNotificationWithHttpInfo(opts).then(function (response) {
        return response.data;
      });
    }
    /**
     * @param {Object} opts Optional parameters
     * @param {String} opts.entityId
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing HTTP response
     */

  }, {
    key: "_deleteResourceWithHttpInfo",
    value: function _deleteResourceWithHttpInfo(opts) {
      opts = opts || {};
      var postBody = null;
      var pathParams = {};
      var queryParams = {
        entityId: opts['entityId']
      };
      var headerParams = {};
      var formParams = {};
      var authNames = [];
      var contentTypes = [];
      var accepts = [];
      var returnType = null;
      return this.apiClient.callApi('/api/Group/Resource/Delete', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType);
    }
    /**
     * @param {Object} opts Optional parameters
     * @param {String} opts.entityId
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}
     */

  }, {
    key: "DeleteResource",
    value: function DeleteResource(opts) {
      return this._deleteResourceWithHttpInfo(opts).then(function (response) {
        return response.data;
      });
    }
    /**
     * @param {Object} opts Optional parameters
     * @param {String} opts.entityId
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:ChiRhos/models/ReportResponse} and HTTP response
     */

  }, {
    key: "_executeReportWithHttpInfo",
    value: function _executeReportWithHttpInfo(opts) {
      opts = opts || {};
      var postBody = null;
      var pathParams = {};
      var queryParams = {
        entityId: opts['entityId']
      };
      var headerParams = {};
      var formParams = {};
      var authNames = [];
      var contentTypes = [];
      var accepts = ['text/plain', 'application/json', 'text/json'];
      var returnType = _ReportResponse["default"];
      return this.apiClient.callApi('/api/Group/Report/Execute', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType);
    }
    /**
     * @param {Object} opts Optional parameters
     * @param {String} opts.entityId
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:ChiRhos/models/ReportResponse}
     */

  }, {
    key: "ExecuteReport",
    value: function ExecuteReport(opts) {
      return this._executeReportWithHttpInfo(opts).then(function (response) {
        return response.data;
      });
    }
    /**
     * @param {Object} opts Optional parameters
     * @param {module:ChiRhos/models/ApiEntityRequest} opts.request
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:ChiRhos/models/DataSecurableResponse} and HTTP response
     */

  }, {
    key: "_getWithHttpInfo",
    value: function _getWithHttpInfo(opts) {
      opts = opts || {};
      var postBody = opts['request'];
      var pathParams = {};
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = [];
      var contentTypes = ['application/json-patch+json', 'application/json', 'text/json', 'application/_*+json'];
      var accepts = ['text/plain', 'application/json', 'text/json'];
      var returnType = _DataSecurableResponse["default"];
      return this.apiClient.callApi('/api/Group/Get', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType);
    }
    /**
     * @param {Object} opts Optional parameters
     * @param {module:ChiRhos/models/ApiEntityRequest} opts.request
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:ChiRhos/models/DataSecurableResponse}
     */

  }, {
    key: "Get",
    value: function Get(opts) {
      return this._getWithHttpInfo(opts).then(function (response) {
        return response.data;
      });
    }
    /**
     * @param {Object} opts Optional parameters
     * @param {module:ChiRhos/models/ApiEntityRequest} opts.request
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:ChiRhos/models/DataResponse} and HTTP response
     */

  }, {
    key: "_getNoteWithHttpInfo",
    value: function _getNoteWithHttpInfo(opts) {
      opts = opts || {};
      var postBody = opts['request'];
      var pathParams = {};
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = [];
      var contentTypes = ['application/json-patch+json', 'application/json', 'text/json', 'application/_*+json'];
      var accepts = ['text/plain', 'application/json', 'text/json'];
      var returnType = _DataResponse["default"];
      return this.apiClient.callApi('/api/Group/Note/Get', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType);
    }
    /**
     * @param {Object} opts Optional parameters
     * @param {module:ChiRhos/models/ApiEntityRequest} opts.request
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:ChiRhos/models/DataResponse}
     */

  }, {
    key: "GetNote",
    value: function GetNote(opts) {
      return this._getNoteWithHttpInfo(opts).then(function (response) {
        return response.data;
      });
    }
    /**
     * @param {Object} opts Optional parameters
     * @param {module:ChiRhos/models/ApiEntityRequest} opts.request
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:ChiRhos/models/DataResponse} and HTTP response
     */

  }, {
    key: "_getPersonNoteWithHttpInfo",
    value: function _getPersonNoteWithHttpInfo(opts) {
      opts = opts || {};
      var postBody = opts['request'];
      var pathParams = {};
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = [];
      var contentTypes = ['application/json-patch+json', 'application/json', 'text/json', 'application/_*+json'];
      var accepts = ['text/plain', 'application/json', 'text/json'];
      var returnType = _DataResponse["default"];
      return this.apiClient.callApi('/api/Group/Note/Person/Get', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType);
    }
    /**
     * @param {Object} opts Optional parameters
     * @param {module:ChiRhos/models/ApiEntityRequest} opts.request
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:ChiRhos/models/DataResponse}
     */

  }, {
    key: "GetPersonNote",
    value: function GetPersonNote(opts) {
      return this._getPersonNoteWithHttpInfo(opts).then(function (response) {
        return response.data;
      });
    }
    /**
     * @param {Object} opts Optional parameters
     * @param {module:ChiRhos/models/ApiEntityRequest} opts.request
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:ChiRhos/models/Stream} and HTTP response
     */

  }, {
    key: "_getResourceFileWithHttpInfo",
    value: function _getResourceFileWithHttpInfo(opts) {
      opts = opts || {};
      var postBody = opts['request'];
      var pathParams = {};
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = [];
      var contentTypes = ['application/json-patch+json', 'application/json', 'text/json', 'application/_*+json'];
      var accepts = ['text/plain', 'application/json', 'text/json'];
      var returnType = _Stream["default"];
      return this.apiClient.callApi('/api/Group/Resource/File', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType);
    }
    /**
     * @param {Object} opts Optional parameters
     * @param {module:ChiRhos/models/ApiEntityRequest} opts.request
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:ChiRhos/models/Stream}
     */

  }, {
    key: "GetResourceFile",
    value: function GetResourceFile(opts) {
      return this._getResourceFileWithHttpInfo(opts).then(function (response) {
        return response.data;
      });
    }
    /**
     * @param {Object} opts Optional parameters
     * @param {module:ChiRhos/models/ApiEntityRequest} opts.request
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:ChiRhos/models/GroupUsageResponse} and HTTP response
     */

  }, {
    key: "_getUsageWithHttpInfo",
    value: function _getUsageWithHttpInfo(opts) {
      opts = opts || {};
      var postBody = opts['request'];
      var pathParams = {};
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = [];
      var contentTypes = ['application/json-patch+json', 'application/json', 'text/json', 'application/_*+json'];
      var accepts = ['text/plain', 'application/json', 'text/json'];
      var returnType = _GroupUsageResponse["default"];
      return this.apiClient.callApi('/api/Group/GetUsage', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType);
    }
    /**
     * @param {Object} opts Optional parameters
     * @param {module:ChiRhos/models/ApiEntityRequest} opts.request
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:ChiRhos/models/GroupUsageResponse}
     */

  }, {
    key: "GetUsage",
    value: function GetUsage(opts) {
      return this._getUsageWithHttpInfo(opts).then(function (response) {
        return response.data;
      });
    }
    /**
     * @param {Object} opts Optional parameters
     * @param {module:ChiRhos/models/InviteConstruct} opts.value
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing HTTP response
     */

  }, {
    key: "_inviteWithHttpInfo",
    value: function _inviteWithHttpInfo(opts) {
      opts = opts || {};
      var postBody = opts['value'];
      var pathParams = {};
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = [];
      var contentTypes = ['application/json-patch+json', 'application/json', 'text/json', 'application/_*+json'];
      var accepts = [];
      var returnType = null;
      return this.apiClient.callApi('/api/Group/Invite', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType);
    }
    /**
     * @param {Object} opts Optional parameters
     * @param {module:ChiRhos/models/InviteConstruct} opts.value
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}
     */

  }, {
    key: "Invite",
    value: function Invite(opts) {
      return this._inviteWithHttpInfo(opts).then(function (response) {
        return response.data;
      });
    }
    /**
     * @param {Object} opts Optional parameters
     * @param {module:ChiRhos/models/ApiEntityPagedRequest} opts.request
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:ChiRhos/models/PagedSecurableResponse} and HTTP response
     */

  }, {
    key: "_listChildGroupsWithHttpInfo",
    value: function _listChildGroupsWithHttpInfo(opts) {
      opts = opts || {};
      var postBody = opts['request'];
      var pathParams = {};
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = [];
      var contentTypes = ['application/json-patch+json', 'application/json', 'text/json', 'application/_*+json'];
      var accepts = ['text/plain', 'application/json', 'text/json'];
      var returnType = _PagedSecurableResponse["default"];
      return this.apiClient.callApi('/api/Group/ListChildGroups', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType);
    }
    /**
     * @param {Object} opts Optional parameters
     * @param {module:ChiRhos/models/ApiEntityPagedRequest} opts.request
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:ChiRhos/models/PagedSecurableResponse}
     */

  }, {
    key: "ListChildGroups",
    value: function ListChildGroups(opts) {
      return this._listChildGroupsWithHttpInfo(opts).then(function (response) {
        return response.data;
      });
    }
    /**
     * Lists all descendants of a group
     * Can only be called by Tenant Owners or Administrators
     * @param {Object} opts Optional parameters
     * @param {module:ChiRhos/models/ApiEntityRequest} opts.request
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:ChiRhos/models/DataResponse} and HTTP response
     */

  }, {
    key: "_listDescendantsWithHttpInfo",
    value: function _listDescendantsWithHttpInfo(opts) {
      opts = opts || {};
      var postBody = opts['request'];
      var pathParams = {};
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = [];
      var contentTypes = ['application/json-patch+json', 'application/json', 'text/json', 'application/_*+json'];
      var accepts = ['text/plain', 'application/json', 'text/json'];
      var returnType = _DataResponse["default"];
      return this.apiClient.callApi('/api/Group/ListDescendants', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType);
    }
    /**
     * Lists all descendants of a group
     * Can only be called by Tenant Owners or Administrators
     * @param {Object} opts Optional parameters
     * @param {module:ChiRhos/models/ApiEntityRequest} opts.request
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:ChiRhos/models/DataResponse}
     */

  }, {
    key: "ListDescendants",
    value: function ListDescendants(opts) {
      return this._listDescendantsWithHttpInfo(opts).then(function (response) {
        return response.data;
      });
    }
    /**
     * @param {Object} opts Optional parameters
     * @param {module:ChiRhos/models/ApiEntityPagedRequest} opts.request
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:ChiRhos/models/PagedResponse} and HTTP response
     */

  }, {
    key: "_listNotesWithHttpInfo",
    value: function _listNotesWithHttpInfo(opts) {
      opts = opts || {};
      var postBody = opts['request'];
      var pathParams = {};
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = [];
      var contentTypes = ['application/json-patch+json', 'application/json', 'text/json', 'application/_*+json'];
      var accepts = ['text/plain', 'application/json', 'text/json'];
      var returnType = _PagedResponse["default"];
      return this.apiClient.callApi('/api/Group/Note/List', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType);
    }
    /**
     * @param {Object} opts Optional parameters
     * @param {module:ChiRhos/models/ApiEntityPagedRequest} opts.request
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:ChiRhos/models/PagedResponse}
     */

  }, {
    key: "ListNotes",
    value: function ListNotes(opts) {
      return this._listNotesWithHttpInfo(opts).then(function (response) {
        return response.data;
      });
    }
    /**
     * Note that this lists all the notes for all persons for the specified group, not all the notes for a person. For a person&#39;s notes, use /api/Person/Note/List
     * @param {Object} opts Optional parameters
     * @param {module:ChiRhos/models/ApiEntityPagedRequest} opts.request
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:ChiRhos/models/PagedResponse} and HTTP response
     */

  }, {
    key: "_listPersonNotesWithHttpInfo",
    value: function _listPersonNotesWithHttpInfo(opts) {
      opts = opts || {};
      var postBody = opts['request'];
      var pathParams = {};
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = [];
      var contentTypes = ['application/json-patch+json', 'application/json', 'text/json', 'application/_*+json'];
      var accepts = ['text/plain', 'application/json', 'text/json'];
      var returnType = _PagedResponse["default"];
      return this.apiClient.callApi('/api/Group/Note/Person/List', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType);
    }
    /**
     * Note that this lists all the notes for all persons for the specified group, not all the notes for a person. For a person&#39;s notes, use /api/Person/Note/List
     * @param {Object} opts Optional parameters
     * @param {module:ChiRhos/models/ApiEntityPagedRequest} opts.request
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:ChiRhos/models/PagedResponse}
     */

  }, {
    key: "ListPersonNotes",
    value: function ListPersonNotes(opts) {
      return this._listPersonNotesWithHttpInfo(opts).then(function (response) {
        return response.data;
      });
    }
    /**
     * @param {Object} opts Optional parameters
     * @param {module:ChiRhos/models/ApiEntityRequest} opts.request
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:ChiRhos/models/IDataResponseIEnumerableIStorableIReport} and HTTP response
     */

  }, {
    key: "_listReportWithHttpInfo",
    value: function _listReportWithHttpInfo(opts) {
      opts = opts || {};
      var postBody = opts['request'];
      var pathParams = {};
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = [];
      var contentTypes = ['application/json-patch+json', 'application/json', 'text/json', 'application/_*+json'];
      var accepts = ['text/plain', 'application/json', 'text/json'];
      var returnType = _DataResponse["default"];
      return this.apiClient.callApi('/api/Group/Report/List', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType);
    }
    /**
     * @param {Object} opts Optional parameters
     * @param {module:ChiRhos/models/ApiEntityRequest} opts.request
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:ChiRhos/models/IDataResponseIEnumerableIStorableIReport}
     */

  }, {
    key: "ListReport",
    value: function ListReport(opts) {
      return this._listReportWithHttpInfo(opts).then(function (response) {
        return response.data;
      });
    }
    /**
     * @param {Object} opts Optional parameters
     * @param {module:ChiRhos/models/ApiEntityPagedRequest} opts.request
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:ChiRhos/models/PagedSecurableResponse} and HTTP response
     */

  }, {
    key: "_listResourcesWithHttpInfo",
    value: function _listResourcesWithHttpInfo(opts) {
      opts = opts || {};
      var postBody = opts['request'];
      var pathParams = {};
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = [];
      var contentTypes = ['application/json-patch+json', 'application/json', 'text/json', 'application/_*+json'];
      var accepts = ['text/plain', 'application/json', 'text/json'];
      var returnType = _PagedSecurableResponse["default"];
      return this.apiClient.callApi('/api/Group/Resource/List', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType);
    }
    /**
     * @param {Object} opts Optional parameters
     * @param {module:ChiRhos/models/ApiEntityPagedRequest} opts.request
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:ChiRhos/models/PagedSecurableResponse}
     */

  }, {
    key: "ListResources",
    value: function ListResources(opts) {
      return this._listResourcesWithHttpInfo(opts).then(function (response) {
        return response.data;
      });
    }
    /**
     * @param {Object} opts Optional parameters
     * @param {module:ChiRhos/models/ApiPagedFilteredRequest} opts.request
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:ChiRhos/models/PagedResponse} and HTTP response
     */

  }, {
    key: "_listRootGroupsWithHttpInfo",
    value: function _listRootGroupsWithHttpInfo(opts) {
      opts = opts || {};
      var postBody = opts['request'];
      var pathParams = {};
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = [];
      var contentTypes = ['application/json-patch+json', 'application/json', 'text/json', 'application/_*+json'];
      var accepts = ['text/plain', 'application/json', 'text/json'];
      var returnType = _PagedResponse["default"];
      return this.apiClient.callApi('/api/Group/ListRootGroups', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType);
    }
    /**
     * @param {Object} opts Optional parameters
     * @param {module:ChiRhos/models/ApiPagedFilteredRequest} opts.request
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:ChiRhos/models/PagedResponse}
     */

  }, {
    key: "ListRootGroups",
    value: function ListRootGroups(opts) {
      return this._listRootGroupsWithHttpInfo(opts).then(function (response) {
        return response.data;
      });
    }
    /**
     * Note that the Order and Sort are ignored for this call as it is ordered by ranking
     * @param {Object} opts Optional parameters
     * @param {module:ChiRhos/models/ApiSearchPagedRequest} opts.request
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:ChiRhos/models/PagedResponse} and HTTP response
     */

  }, {
    key: "_lookupWithHttpInfo",
    value: function _lookupWithHttpInfo(opts) {
      opts = opts || {};
      var postBody = opts['request'];
      var pathParams = {};
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = [];
      var contentTypes = ['application/json-patch+json', 'application/json', 'text/json', 'application/_*+json'];
      var accepts = ['text/plain', 'application/json', 'text/json'];
      var returnType = _PagedResponse["default"];
      return this.apiClient.callApi('/api/Group/Lookup', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType);
    }
    /**
     * Note that the Order and Sort are ignored for this call as it is ordered by ranking
     * @param {Object} opts Optional parameters
     * @param {module:ChiRhos/models/ApiSearchPagedRequest} opts.request
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:ChiRhos/models/PagedResponse}
     */

  }, {
    key: "Lookup",
    value: function Lookup(opts) {
      return this._lookupWithHttpInfo(opts).then(function (response) {
        return response.data;
      });
    }
    /**
     * @param {Object} opts Optional parameters
     * @param {module:ChiRhos/models/GroupConstruct} opts.value
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:ChiRhos/models/DataSecurableResponse} and HTTP response
     */

  }, {
    key: "_saveWithHttpInfo",
    value: function _saveWithHttpInfo(opts) {
      opts = opts || {};
      var postBody = opts['value'];
      var pathParams = {};
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = [];
      var contentTypes = ['application/json-patch+json', 'application/json', 'text/json', 'application/_*+json'];
      var accepts = ['text/plain', 'application/json', 'text/json'];
      var returnType = _DataSecurableResponse["default"];
      return this.apiClient.callApi('/api/Group', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType);
    }
    /**
     * @param {Object} opts Optional parameters
     * @param {module:ChiRhos/models/GroupConstruct} opts.value
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:ChiRhos/models/DataSecurableResponse}
     */

  }, {
    key: "Save",
    value: function Save(opts) {
      return this._saveWithHttpInfo(opts).then(function (response) {
        return response.data;
      });
    }
    /**
     * @param {Object} opts Optional parameters
     * @param {module:ChiRhos/models/ApiAddNoteRequest} opts.request
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:ChiRhos/models/DataResponse} and HTTP response
     */

  }, {
    key: "_saveNoteWithHttpInfo",
    value: function _saveNoteWithHttpInfo(opts) {
      opts = opts || {};
      var postBody = opts['request'];
      var pathParams = {};
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = [];
      var contentTypes = ['application/json-patch+json', 'application/json', 'text/json', 'application/_*+json'];
      var accepts = ['text/plain', 'application/json', 'text/json'];
      var returnType = _DataResponse["default"];
      return this.apiClient.callApi('/api/Group/Note', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType);
    }
    /**
     * @param {Object} opts Optional parameters
     * @param {module:ChiRhos/models/ApiAddNoteRequest} opts.request
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:ChiRhos/models/DataResponse}
     */

  }, {
    key: "SaveNote",
    value: function SaveNote(opts) {
      return this._saveNoteWithHttpInfo(opts).then(function (response) {
        return response.data;
      });
    }
    /**
     * @param {Object} opts Optional parameters
     * @param {module:ChiRhos/models/ApiAddNotePersonRequest} opts.request
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:ChiRhos/models/DataResponse} and HTTP response
     */

  }, {
    key: "_savePersonNoteWithHttpInfo",
    value: function _savePersonNoteWithHttpInfo(opts) {
      opts = opts || {};
      var postBody = opts['request'];
      var pathParams = {};
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = [];
      var contentTypes = ['application/json-patch+json', 'application/json', 'text/json', 'application/_*+json'];
      var accepts = ['text/plain', 'application/json', 'text/json'];
      var returnType = _DataResponse["default"];
      return this.apiClient.callApi('/api/Group/Note/Person', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType);
    }
    /**
     * @param {Object} opts Optional parameters
     * @param {module:ChiRhos/models/ApiAddNotePersonRequest} opts.request
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:ChiRhos/models/DataResponse}
     */

  }, {
    key: "SavePersonNote",
    value: function SavePersonNote(opts) {
      return this._savePersonNoteWithHttpInfo(opts).then(function (response) {
        return response.data;
      });
    }
    /**
     * Pass in a multipart form with two parameters: file [File] and resourceJson [Text], with the resourceJson holding a ResourceConstruct
     * @param {Object} opts Optional parameters
     * @param {String} opts.contentType
     * @param {String} opts.contentDisposition
     * @param {Object.<String, {String: String}>} opts.headers
     * @param {Number} opts.length
     * @param {String} opts.name
     * @param {String} opts.fileName
     * @param {String} opts.resourceJson
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:ChiRhos/models/DataSecurableResponse} and HTTP response
     */

  }, {
    key: "_saveResourceWithHttpInfo",
    value: function _saveResourceWithHttpInfo(opts) {
      opts = opts || {};
      var postBody = null;
      var pathParams = {};
      var queryParams = {
        ContentType: opts['contentType'],
        ContentDisposition: opts['contentDisposition'],
        Headers: opts['headers'],
        Length: opts['length'],
        Name: opts['name'],
        FileName: opts['fileName'],
        resourceJson: opts['resourceJson']
      };
      var headerParams = {};
      var formParams = {};
      var authNames = [];
      var contentTypes = [];
      var accepts = ['text/plain', 'application/json', 'text/json'];
      var returnType = _DataSecurableResponse["default"];
      return this.apiClient.callApi('/api/Group/Resource/Save', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType);
    }
    /**
     * Pass in a multipart form with two parameters: file [File] and resourceJson [Text], with the resourceJson holding a ResourceConstruct
     * @param {Object} opts Optional parameters
     * @param {String} opts.contentType
     * @param {String} opts.contentDisposition
     * @param {Object.<String, {String: String}>} opts.headers
     * @param {Number} opts.length
     * @param {String} opts.name
     * @param {String} opts.fileName
     * @param {String} opts.resourceJson
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:ChiRhos/models/DataSecurableResponse}
     */

  }, {
    key: "SaveResource",
    value: function SaveResource(opts) {
      return this._saveResourceWithHttpInfo(opts).then(function (response) {
        return response.data;
      });
    }
    /**
     * @param {Object} opts Optional parameters
     * @param {String} opts.entityId
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing HTTP response
     */

  }, {
    key: "_restoreWithHttpInfo",
    value: function _restoreWithHttpInfo(opts) {
      opts = opts || {};
      var postBody = null;
      var pathParams = {};
      var queryParams = {
        entityId: opts['entityId']
      };
      var headerParams = {};
      var formParams = {};
      var authNames = [];
      var contentTypes = [];
      var accepts = [];
      var returnType = null;
      return this.apiClient.callApi('/api/Group/Restore', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType);
    }
    /**
     * @param {Object} opts Optional parameters
     * @param {String} opts.entityId
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}
     */

  }, {
    key: "Restore",
    value: function Restore(opts) {
      return this._restoreWithHttpInfo(opts).then(function (response) {
        return response.data;
      });
    }
    /**
     * @param {Object} opts Optional parameters
     * @param {module:ChiRhos/models/ReportConstruct} opts.value
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:ChiRhos/models/ReportResponse} and HTTP response
     */

  }, {
    key: "_runReportWithHttpInfo",
    value: function _runReportWithHttpInfo(opts) {
      opts = opts || {};
      var postBody = opts['value'];
      var pathParams = {};
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = [];
      var contentTypes = ['application/json-patch+json', 'application/json', 'text/json', 'application/_*+json'];
      var accepts = ['text/plain', 'application/json', 'text/json'];
      var returnType = _ReportResponse["default"];
      return this.apiClient.callApi('/api/Group/Report/Run', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType);
    }
    /**
     * @param {Object} opts Optional parameters
     * @param {module:ChiRhos/models/ReportConstruct} opts.value
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:ChiRhos/models/ReportResponse}
     */

  }, {
    key: "RunReport",
    value: function RunReport(opts) {
      return this._runReportWithHttpInfo(opts).then(function (response) {
        return response.data;
      });
    }
    /**
     * @param {Object} opts Optional parameters
     * @param {module:ChiRhos/models/ReportConstruct} opts.value
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing HTTP response
     */

  }, {
    key: "_saveReportWithHttpInfo",
    value: function _saveReportWithHttpInfo(opts) {
      opts = opts || {};
      var postBody = opts['value'];
      var pathParams = {};
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = [];
      var contentTypes = ['application/json-patch+json', 'application/json', 'text/json', 'application/_*+json'];
      var accepts = [];
      var returnType = null;
      return this.apiClient.callApi('/api/Group/Report/Save', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType);
    }
    /**
     * @param {Object} opts Optional parameters
     * @param {module:ChiRhos/models/ReportConstruct} opts.value
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}
     */

  }, {
    key: "SaveReport",
    value: function SaveReport(opts) {
      return this._saveReportWithHttpInfo(opts).then(function (response) {
        return response.data;
      });
    }
    /**
     * @param {Object} opts Optional parameters
     * @param {module:ChiRhos/models/ReportConstruct} opts.value
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing HTTP response
     */

  }, {
    key: "_saveReportForGroupTypeWithHttpInfo",
    value: function _saveReportForGroupTypeWithHttpInfo(opts) {
      opts = opts || {};
      var postBody = opts['value'];
      var pathParams = {};
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = [];
      var contentTypes = ['application/json-patch+json', 'application/json', 'text/json', 'application/_*+json'];
      var accepts = [];
      var returnType = null;
      return this.apiClient.callApi('/api/Group/Report/SaveForGroupType', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType);
    }
    /**
     * @param {Object} opts Optional parameters
     * @param {module:ChiRhos/models/ReportConstruct} opts.value
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}
     */

  }, {
    key: "SaveReportForGroupType",
    value: function SaveReportForGroupType(opts) {
      return this._saveReportForGroupTypeWithHttpInfo(opts).then(function (response) {
        return response.data;
      });
    }
    /**
     * @param {Object} opts Optional parameters
     * @param {module:ChiRhos/models/ApiSecurityRequest} opts.request
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:ChiRhos/models/DataSecurableResponse} and HTTP response
     */

  }, {
    key: "_setSecurityWithHttpInfo",
    value: function _setSecurityWithHttpInfo(opts) {
      opts = opts || {};
      var postBody = opts['request'];
      var pathParams = {};
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = [];
      var contentTypes = ['application/json-patch+json', 'application/json', 'text/json', 'application/_*+json'];
      var accepts = ['text/plain', 'application/json', 'text/json'];
      var returnType = _DataSecurableResponse["default"];
      return this.apiClient.callApi('/api/Group/SetSecurity', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType);
    }
    /**
     * @param {Object} opts Optional parameters
     * @param {module:ChiRhos/models/ApiSecurityRequest} opts.request
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:ChiRhos/models/DataSecurableResponse}
     */

  }, {
    key: "SetSecurity",
    value: function SetSecurity(opts) {
      return this._setSecurityWithHttpInfo(opts).then(function (response) {
        return response.data;
      });
    }
    /**
     * @param {Object} opts Optional parameters
     * @param {module:ChiRhos/models/ApiSubscriptionUpdateRequest} opts.request
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:ChiRhos/models/DataSecurableResponse} and HTTP response
     */

  }, {
    key: "_updateSubscriptionWithHttpInfo",
    value: function _updateSubscriptionWithHttpInfo(opts) {
      opts = opts || {};
      var postBody = opts['request'];
      var pathParams = {};
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = [];
      var contentTypes = ['application/json-patch+json', 'application/json', 'text/json', 'application/_*+json'];
      var accepts = ['text/plain', 'application/json', 'text/json'];
      var returnType = _DataSecurableResponse["default"];
      return this.apiClient.callApi('/api/Group/UpdateSubscription', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType);
    }
    /**
     * @param {Object} opts Optional parameters
     * @param {module:ChiRhos/models/ApiSubscriptionUpdateRequest} opts.request
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:ChiRhos/models/DataSecurableResponse}
     */

  }, {
    key: "UpdateSubscription",
    value: function UpdateSubscription(opts) {
      return this._updateSubscriptionWithHttpInfo(opts).then(function (response) {
        return response.data;
      });
    }
  }]);
  return GroupApi;
}();

exports["default"] = GroupApi;
module.exports = exports.default;